"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateCommitment = void 0;
var Hash_1 = require("./Hash");
var CommitmentsState;
(function (CommitmentsState) {
    CommitmentsState[CommitmentsState["NoState"] = 1] = "NoState";
    CommitmentsState[CommitmentsState["State"] = 2] = "State";
    CommitmentsState[CommitmentsState["NotCommitted"] = 3] = "NotCommitted";
})(CommitmentsState || (CommitmentsState = {}));
var StateCommitment = /** @class */ (function () {
    function StateCommitment(state, hash) {
        this.state = state;
        if (this.state === CommitmentsState.State)
            this.hash = hash;
    }
    StateCommitment.read = function (buffer, offset) {
        var identifier = buffer.readInt8(offset);
        if (identifier === CommitmentsState.State) {
            var _a = Hash_1.Hash.read(buffer, offset + 1), hash = _a.hash, hash_offset = _a.offset;
            return { stateCommitment: new StateCommitment(CommitmentsState.State, hash), offset: hash_offset };
        }
        else {
            if (identifier === CommitmentsState.NoState || identifier === CommitmentsState.NotCommitted)
                return { stateCommitment: new StateCommitment(identifier), offset: offset + 1 };
        }
        throw 'invalid state-commitment identifier';
    };
    StateCommitment.prototype.getSize = function () {
        if (this.hash)
            return 1 + this.hash.getSize();
        return 1;
    };
    StateCommitment.prototype.toJson = function () {
        if (this.hash) {
            return {
                state: this.state,
                hash: this.hash
            };
        }
        else {
            return {
                state: this.state
            };
        }
    };
    StateCommitment.prototype.write = function (buffer, offset) {
        buffer.writeInt8(this.state, offset);
        if (this.hash)
            return this.hash.write(buffer, offset + 1);
        return offset + 1;
    };
    return StateCommitment;
}());
exports.StateCommitment = StateCommitment;
//# sourceMappingURL=StateCommitment.js.map